<!-- TEMPLATE -->
<template>
    <div :class='partnerDetailsClass'>
        <dean-two-column-layout :title="headerTitle">
            <dean-section-title-item
                v-if="canSavePartnerAgreement()"
                :icon='saveIcon'
                slot="title-items"
                :content="true"
                :large="true"
                @click.native="processPartnerAgreement"
            >
                Opslaan
            </dean-section-title-item>
            <div class="column" slot="left">
                <dean-section-divider>Algemene plangegevens</dean-section-divider>
                <dean-select-form-row placeholder="Kies een partnertype" label='Type partner' :options='partnerTypes'
                                      :value="currentlySelectedOption(agreementData.type, partnerTypes)"
                                      id="partnertype" :required-field="true"
                                      :disabled="! canSavePartnerAgreement()"
                                      :warning="$v.agreementData.type.$error" @focus="$v.agreementData.type.$touch()"
                                      @input="valueChanged($event, 'type'); partnerAgreementTypeRecon();"></dean-select-form-row>
                <dean-form-row id="generic.description" type="text" v-model="agreementData.description"
                               :disabled="! canSavePartnerAgreement()"
                               label="Beschrijving"></dean-form-row>
                <dean-select-form-row placeholder="Kies een partner manager" label='Partner manager'
                                      :options='partnerManagers'
                                      :value="currentlySelectedOption(agreementData.partnerManager, partnerManagers)"
                                      id="partnermanager"
                                      :required-field="true"
                                      :disabled="! canSavePartnerAgreement()"
                                      :warning="$v.agreementData.partnerManager.$error"
                                      @input="valueChanged($event, 'partnerManager')"></dean-select-form-row>
                <dean-multi-select-form-row :multiple="true" placeholder="Kies rollen"
                                            id='generic.Roles'
                                            label='Rollen'
                                            :value="currentRoles"
                                            :options='roles'
                                            :required-field="true"
                                            :disabled="! canSavePartnerAgreement()"
                                            :warning="$v.agreementData.roles.$error"
                                            @select='rolesFieldAdded'
                                            @remove="rolesFieldRemoved"></dean-multi-select-form-row>
              <date-input
                  label="Startdatum"
                  placeholder="Startdatum"
                  :value="agreementData.startDate"
                  :disable-weekends="false"
                  :disable-holidays="false"
                  :required-field="true"
                  :disabled="! canSavePartnerAgreement()"
                  :warning="$v.agreementData.startDate.$error"
                  @dateValueChanged="startDateValueChanged"
              ></date-input>
                <date-input
                    label="Einddatum"
                    placeholder="Einddatum"
                    :value="agreementData.endDate"
                    :min-date="agreementData.startDate"
                    :disable-weekends="false"
                    :disable-holidays="false"
                    :disabled="! canSavePartnerAgreement()"
                    :warning="$v.agreementData.endDate.$error"
                    @dateValueChanged="endDateValueChanged"
                ></date-input>

                <dean-input-switch-form-row id="main" label="Certified plus" :required="true"
                                            :value="agreementData.certificates"
                                            :disabled="! canSavePartnerAgreement()"
                                            @checked="valueChanged($event, 'certificates')"></dean-input-switch-form-row>

                <dean-input-switch-form-row id="webexCertified" label="Webex certified" :required="true"
                                            :value="agreementData.webexCertified"
                                            :disabled="! canSavePartnerAgreement()"
                                            @checked="valueChanged($event, 'webexCertified')"></dean-input-switch-form-row>
            </div>
            <div class="column" slot="right">
                <dean-section-divider>Extra plangegevens</dean-section-divider>
                <dean-select-form-row placeholder="Kies een prijsplan" label='Prijsplan' :options='pricePlans'
                                      :required-field="true"
                                      :disabled="! canSavePartnerAgreement()"
                                      :warning="$v.agreementData.priceplan.$error"
                                      @focus="$v.agreementData.priceplan.$touch()"
                                      :value="currentlySelectedOption(agreementData.priceplan, pricePlans)"
                                      id="priceplan"
                                      @input="valueChanged($event, 'priceplan')"></dean-select-form-row>
                <dean-select-form-row placeholder="Kies een commissieplan" label='Periodiek commissieplan'
                                      :required-field="true"
                                      :options='recurringCommissionPlans'
                                      :warning="$v.agreementData.rcp.$invalid"
                                      :value="currentlySelectedOption(agreementData.rcp, recurringCommissionPlans, 'rcp')"
                                      id="recurringcommissionplan"
                                      :disabled="! canSavePartnerAgreement()"
                                      @input="valueChanged($event, 'rcp'); partnerAgreementTypeRecon();"></dean-select-form-row>
                <dean-select-form-row placeholder="Kies een staffel" label='Staffel kortingsplan'
                                      :options='commissionPlanScales'
                                      :warning="$v.agreementData.commissionGate.$invalid"
                                      :value="currentlySelectedOption(agreementData.commissionGate, commissionPlanScales)"
                                      v-if="agreementData.rcp"
                                      id="recurringcommissionplanscale"
                                      :disabled="! canSavePartnerAgreement()"
                                      @input="valueChanged($event, 'commissionGate')"></dean-select-form-row>
                <dean-form-row id="generic.tmReference" v-model="agreementData.tMobileReference"
                               :disabled="! canSavePartnerAgreement()"
                               label="T-Mobile referentie"></dean-form-row>
                <dean-select-form-row placeholder="Kies een betaalmethode" label='Betaalmethode' :requiredField="true"
                                      :options='paymentMethods'
                                      :value="currentlySelectedOption(agreementData.paymentMethod, paymentMethods)"
                                      id="paymentmethod"
                                      :disabled="! canSavePartnerAgreement()"
                                      :warning="$v.agreementData.paymentMethod.$error"
                                      @input="valueChanged($event, 'paymentMethod')"></dean-select-form-row>
                <dean-form-row id="generic.iban" v-model="agreementData.iban"
                               label="Rekeningnummer (IBAN)" :requiredField="true"
                               @input="$v.$touch()"
                               :disabled="! canSavePartnerAgreement()"
                               :warning="$v.agreementData.iban.$error"></dean-form-row>
            </div>
        </dean-two-column-layout>
    </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
// VUE
  import {
    Vue,
    Component,
    Watch,
  } from 'vue-property-decorator';

  import {
    // SVG
    globeIcon,
    invoicesIcon,
    // COMPONENTS
    deanInputField,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
    deanIcon,
    returnIcon,
    saveIcon,
    summeryIcon,
    partnerIcon,
    businessIcon,
    usersIcon,
    offersIcon,
    ordersIcon,
    commissionIcon,
    customerIcon,
    customerServiceIcon,
    messageIcon,
  } from '@deanone/dean-components';
  import DeanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
  import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import deanInputSelect from '@/components/deanComponents/deanInputSelect.vue';
  import DeanInputSwitchFormRow from '@/components/deanComponents/deanInputSwitchFormRow.vue';
  import DeanMultiSelectFormRow from '@/components/deanComponents/deanMultiSelectFormRow.vue';
  import {validationMixin} from 'vuelidate';
  import {required} from 'vuelidate/lib/validators';
  import {Validations} from 'vuelidate-property-decorators';
  import {createNotificationFromData} from '@/mixins/validations';
  import {iban} from '@/mixins/validators';
  import sideMenuPartnerMixin from '@/mixins/sideMenuPartnerMixin';
  import {mixins} from 'vue-class-component';
  import {getOvDate} from '@/mixins/dateWrapper';
  import DateInput from '@/components/DateInput.vue';
  import {agreementEndDateValidator} from '@/mixins/validators';
  import axios from 'axios';

  @Component({
    components: {
      deanInputField,
      DeanTwoColumnLayout,
      deanInputSelect,
      DeanFormRow,
      DeanSelectFormRow,
      DeanInputSwitchFormRow,
      DeanMultiSelectFormRow,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      invoicesIcon,
      deanIcon,
      returnIcon,
      saveIcon,
      summeryIcon,
      partnerIcon,
      businessIcon,
      usersIcon,
      offersIcon,
      ordersIcon,
      commissionIcon,
      customerIcon,
      customerServiceIcon,
      messageIcon,
      DateInput,
    },
    mixins: [validationMixin],
  })
  export default class PartnersAgreementDetails extends mixins(sideMenuPartnerMixin) {

    public agreementData: {
      id: string|null,
      description: any,
      partner: any,
      certificates: any,
      webexCertified: boolean,
      endDate: any,
      partnerManager: any,
      paymentMethod: any,
      iban: any,
      priceplan: any,
      rcp: any,
      commissionGate: any,
      roles: string[],
      startDate: any,
      tMobileReference: any,
      type: any,
    } = {
      id: null,
      description: null,
      partner: null,
      certificates: false,
      webexCertified: false,
      endDate: null,
      partnerManager: null,
      paymentMethod: null,
      iban: null,
      priceplan: null,
      rcp: null,
      commissionGate: null,
      roles: [],
      startDate: null,
      tMobileReference: null,
      type: null,
    };
    public partnerTypes: Array<{ value: any, label: any }> = [];
    public partnerManagers: Array<{ value: any, label: any }> = [];
    public roles: Array<{ value: any, label: any }> = [];
    public pricePlans: Array<{ value: any, label: any }> = [];
    public recurringCommissionPlans: Array<{ value: any, label: any }> = [];
    public commissionPlanScales: Array<{ value: any, label: any }> = [];
    public paymentMethods: Array<{ value: any, label: any }> = [];

    public returnIcon: object = returnIcon;
    public saveIcon: object = saveIcon;
    public showSomething: boolean = false;
    public timeout?: number;

    // COMPUTED
    @Validations()
    get validations() {
      return {
        agreementData: {
          type: {required},
          iban: {
            required,
            iban,
          },
          paymentMethod: {required},
          partnerManager: {required},
          roles: {required},
          priceplan: {required},
          rcp: {required},
          commissionGate: {required},
          startDate: {required},
          endDate: {agreementEndDateValidator: agreementEndDateValidator(this.agreementData.startDate)},
        },
      };
    }

    get partnerDetailsClass() {
      let value = 'agreement-details';

      if (this.showSomething) {
        value += ' no-scroll-container';
      }

      return value;
    }

    get headerTitle(): string {
      return 'Partner overeenkomst';
    }

    get currentRoles() {
      const roles = this.roles;
      const currentRoles = this.agreementData.roles;
      const foundRoles = [];

      if (currentRoles != null && currentRoles.length) {
        for (const currentRole of currentRoles) {
          const foundKey: any = Object.keys(roles).find((key) =>
            // @ts-ignore-next-line
            roles[key].value === currentRole);
          foundRoles.push(roles[foundKey]);
        }

        return foundRoles;
      }

      return null;
    }

    public partnerAgreementDetails() {
      this.$store.dispatch('setLoadOverlay', true);

      const data = {paid: this.$route.params.paid};

      this.$store.dispatch('requestPartnerAgreement', data).then(
        (response) => {

          this.agreementData = {...this.agreementData, ...response.data.agreement};
          this.agreementData.startDate = response.data.agreement.startDate ? response.data.agreement.startDate : new Date();
          this.partnerTypes = response.data.partnerAgreementTypes;
          this.partnerManagers = response.data.partnerManagers;
          this.paymentMethods = response.data.paymentMethods;
          this.commissionPlanScales = (response.data.agreement.rcp !== null)
            ? response.data.recurringCommissionPlanGates
            : [];
          this.roles = response.data.roles;

          this.agreementData.type = this.agreementData.type
          this.agreementData.certificates = this.agreementData.certificates != null
            ? !!this.agreementData.certificates.length
            : false;
          this.agreementData.roles = this.agreementData.roles != null ? this.agreementData.roles : [];

          this.partnerAgreementTypeRecon();

          this.$store.dispatch('setLoadOverlay', false);
        },
        (error) => {
          this.$store.dispatch('setLoadOverlay', false);
        },
      );
    }

    public partnerAgreementTypeRecon() {
      this.$store.dispatch('setLoadOverlay', true);

      const url = '/-/trade/api/partner.agreement.info';

      axios.post(url, {
        paid: this.$route.params.paid,
        rcp: this.agreementData.rcp,
      }).then(
        // tslint:disable-next-line
        (response) => {
          this.pricePlans = response.data.pricePlans;
          this.recurringCommissionPlans = response.data.recurringCommissionPlans;
          this.commissionPlanScales = response.data.recurringCommissionPlanGates;
        },
        // tslint:disable-next-line
        (error) => {
          // Handle error
        },
      ).finally(
        () => {
          this.$store.dispatch('setLoadOverlay', false);
        },
      );
    }

    public created() {
      this.partnerAgreementDetails();
      this.buildSideMenuPartner();

      console.log("data", this.roles)
    }

    public sectionRoute(name: string) {
      this.$router.push({name});
    }

    public currentlySelectedOption(value: any, options: any, type: any) {
      if (value !== null) {
        const foundKey: any = Object.keys(options).find((key) => options[key].value === value);
        return foundKey != null ? options[foundKey] : null;
      }

      return null;
    }

    public valueChanged(field: any, id: string) {
      (this.agreementData as any)[id] = field.value;
    }

    public startDateValueChanged(data: string) {
      this.agreementData.startDate = data;
    }

    public endDateValueChanged(data: string) {
      this.agreementData.endDate = data;
    }

    public rolesFieldAdded(field: any) {
      this.agreementData.roles.push(field.value);
    }

    public rolesFieldRemoved(removedRole: { value: any, label: any }) {
      const currentRoles = this.agreementData.roles;
      this.agreementData.roles = this.agreementData.roles.filter(
        (role: string) => {
          return role !== removedRole.value;
        },
      );
    }

    public processPartnerAgreement() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$store.dispatch('setLoadOverlay', true);

        const url = '/-/trade/api/partner.agreement.save';

        const data = {
          pid: this.$route.params.pid,
          paid: this.$route.params.paid,
          type: this.agreementData.type,
          description: this.agreementData.description,
          partnerManager: this.agreementData.partnerManager,
          roles: this.agreementData.roles,
          startDate: getOvDate(this.agreementData.startDate),
          endDate: getOvDate(this.agreementData.endDate),
          certifiedPlus: this.agreementData.certificates,
          webexCertified: this.agreementData.webexCertified,
          pricePlan: this.agreementData.priceplan,
          recurringCommissionPlan: this.agreementData.rcp,
          recurringCommissionPlanGate: (this.agreementData.commissionGate) ? this.agreementData.commissionGate : null,
          tMobileReference: this.agreementData.tMobileReference,
          paymentMethod: this.agreementData.paymentMethod,
          iban: this.agreementData.iban,
        };

        axios.post(url, data).then(
          (response) => {
            this.agreementData = response.data;
            this.$router.push({
                name: 'partners.agreements.list',
                params: {pid: response.data.partner},
            }).then(
                () => {
                    this.$store.dispatch('setLoadOverlay', false);
                    this.$toast({
                        icon: saveIcon,
                        text: 'Overeenkomst opgeslagen',
                        theme: 'success',
                    });
                });
          },
          (error) => {
            this.$toast({
              icon: saveIcon,
              text: 'Er is iets misgegaan. Ga na of de velden correct zijn ingevuld en probeer het nogmaals.',
              theme: 'danger',
            });
            this.$store.dispatch('setLoadOverlay', false);
          },
        );
      } else {
        this.$toast(createNotificationFromData(this.$v.agreementData));
      }
    }

    public canSavePartnerAgreement(): boolean {
      if (
          this.agreementData?.id
          && this.$store.getters.getUser.privileges.includes('update-partner-agreement')
      ) {
        return true;
      }

      if (
          this.agreementData?.id === null
          && this.$store.getters.getUser.privileges.includes('create-partner-agreement')
      ) {
        return true;
      }

      return false;
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
    @import '~@deanone/dean-components/src/scss/vars';
</style>
